import React from 'react';
import moment from 'moment';
import '../../css/formats.css';
import { CURRENCY, Datos_Empresa, FORMAT_NUMBER, SYMBOL } from "../../libs/utils/Const";
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";

class TicketPaid extends React.Component {


    render() {
        const {  DocLines, DocHeader, InfoByFolio } = this.props
        let totalLetra = '';

        let numeroLetra = new NumeroLetra();
        totalLetra = numeroLetra.NumeroALetras("SOL", Number(Number(DocHeader.DocTotal).toFixed(2)));
        
        return (
            <div>
                <div className='row'>
                    <div className='col-4'></div>
                    <div className='col-4'>
                        <div style={{ backgroundColor: 'white', width: "322px", height: "auto", marginLeft: "auto", marginRight: "auto", border: "solid 1px" }}>
                        <div className='row p-3'>
                                <div className='col-12 text-center'>
                                    <span><strong>COMPROBANTE DE PAGO</strong></span>
                                </div>
                            </div>
                            <div className='row p-3'>
                                <div className="col-12 text-center text-ticket">
                                    <img src={development? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" style={{maxWidth:"170px"}}/>
                                    <p><strong>{Datos_Empresa.Nombre}<br/>{Datos_Empresa.Sociedad}<br/>{Datos_Empresa.RFC}</strong></p>                                        
                                    <p >COL. C.P.;,.</p>
                                    <span >Tel. Cel.</span>
                                </div>
                            </div>
                            <div className='row p-3'>
                                <div className='col-12 text-ticket '>
                                    <table>
                                        <tbody style={{borderTop: "solid 2px", borderBottom: "solid 2px"}}>
                                            <tr>
                                                <td>FOLIO: </td>
                                                <td className='text-right'>A00A0CCA4647</td>
                                            </tr>
                                            <tr>
                                                <td>FECHA: </td>
                                                <td className='text-right'>15/08/2022 01:14 PM</td>
                                            </tr>
                                            <br/>
                                            <tr>
                                                <td>Doc. de origen: </td>
                                                <td className='text-right'></td>
                                            </tr>
                                            <tr>
                                                <td>RÉGIMEN FISCAL:</td>
                                                <td className='text-right'>PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL</td>
                                            </tr>
                                            <tr>
                                                <td>Asesor/a de ventas: </td>
                                                <td className='text-right'>VENTA DE PISO MATRIZ</td>
                                            </tr>
                                            <tr>
                                                <td>Cajero/a: </td>
                                                <td className='text-right'>5,125</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div> 
                            <div className='row pl-3 pr-3'>
                                <div className='col-12 text-ticket '>
                                    <div className='text-center pb-3'>
                                        <span><strong>DATOS DEL CLIENTE</strong></span>
                                    </div>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td>NOMBRE: </td>
                                                <td className='text-right'>VENTA DE MOSTRADOR</td>
                                            </tr>
                                            <tr>
                                                <td>CLAVE: CA001</td>
                                                <td className='text-right'>RUT: XAXX010101000</td>
                                            </tr>
                                            <tr>
                                                <td>TELÉFONO: </td>
                                                <td className='text-right'></td>
                                            </tr>
                                            <tr>
                                                <td>RÉGIMEN FISCAL:</td>
                                                <td className='text-right'>PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br/>
                                    <span>Dirección de Fiscal:</span>
                                    <p>
                                        No.  Col.  C.P , ,
                                    </p>
                                    <span>Dirección de entrega:</span>
                                    <p>
                                        {Datos_Empresa.Calle} #{Datos_Empresa.Numero} COL. {Datos_Empresa.Colonia},{Datos_Empresa.Ciudad}, {Datos_Empresa.Estado}. C.P.{Datos_Empresa.CP}
                                    </p>
                                </div>
                            </div>
                            <div className='row pl-3 pr-3'>
                                <div className='col-12 text-ticket '>
                                    <div>
                                        <span>MONEDA: SOL</span>
                                    </div>
                                    <table>
                                        <thead style={{borderBottom: "solid 2px"}}>
                                            <tr>
                                                <th colSpan={5}>Folio: 0000000000000</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colSpan={5}>
                                                    <img src={require('../../images/sello.png')} alt="Sello" style={{width:"275px"}}/>
                                                </td>
                                            </tr>
                                            
                                            <br/> 
                                            <tr>
                                                <td className='text-left'colSpan="2"><strong>SUB TOTAL</strong></td>
                                                <td className='text-right' colSpan="3"><strong>251.34</strong></td>
                                            </tr>
                                            <tr>
                                                <td className='text-left'colSpan="2"><strong>IVA</strong></td>
                                                <td className='text-right' colSpan="3"><strong>40.21</strong></td>
                                            </tr>
                                            <tr>
                                                <td className='text-left' colSpan="2"><strong>TOTAL</strong></td>
                                                <td className='text-right' colSpan="3"><strong>291.55</strong></td>
                                            </tr>
                                            <br/> 
                                            <tr>
                                                <td colSpan="5">DOSCIENTOS NOVENTA Y UN SOLES 55/100 M.N</td>
                                            </tr>                                             
                                        </tbody>
                                    </table>
                                    <br/> 
                                    <p>Comentarios: Basado en venta de Counter One<br/>A00A0CCA4647</p> 
                                </div>
                            </div>
                            <div className='row pl-4 pr-4'>
                                <div className='text-center text-ticket-xs'>
                                    <p>
                                    Sin más por el momento y en espera de vernos favorecidos,
                                    quedo de Usted para cualquier duda o aclaración.
                                    * Precios Sujetos a Cambio Sin Previo Aviso.
                                    ** Los precios arriba cotizados son para los volúmenes 
                                    solicitados, por lo que al variar estos los precios pueden verse
                                    afectados.<br/>
                                    *** Maniobras de descarga a cargo del cliente.
                                    Toda cancelación o devolución sólo será efectiva presentando 
                                    la nota y en un plazo no mayor a 7 días.
                                    Si se requiere factura, es en un plazo no mayor a 7 días, y/o
                                    en los casos que aplique, antes de cierre de mes.
                                    </p><br/><br/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-4'></div>

                </div>

            </div>
        )
    }
}

export default TicketPaid